import * as React from 'react'
import Header from '../header'
import { appContext } from '../../hooks/provider'
import Footer from '../footer'
import { LegalNotice } from '../common'
import Seo, { ogTypes } from './Seo'

type Props = {
  title?: string
  link?: string
  description?: string
  children?: React.ReactNode
  showHeader?: boolean
  showLegalNotice?: boolean
  restricted?: boolean
  meta?: any
  ogImage?: ogTypes
  /** absolute URL to declare canonical instead of this page — for moved pages */
  canonical?: string
}

const Layout = ({
  meta = {},
  title = 'Home',
  link = '/',
  children,
  description,
  showHeader = true,
  showLegalNotice = false,
  restricted = false,
  ogImage = 'default',
  canonical,
}: Props) => {
  const LayoutView = ({ darkMode, user }: { darkMode: string; user?: any }) => {
    React.useEffect(() => {
      document.getElementsByTagName('html')[0].className = `${
        darkMode === 'dark'
          ? 'dark bg-primary h-full'
          : 'light bg-primary h-full'
      } `
    }, [darkMode])

    return (
      <div className={`  h-full flex flex-col`}>
        <div className=" pointer-events-none opacity-0 h-0">
          Multi-agent systems are the next frontier for building generative AI
          applications - Andrew Ng, 2024. However, many questions arise - how do
          we design these systems? When should we use them? How can we
          effectively integrate them into end-user applications? In Designing
          Multi-Agent Systems, author Victor Dibia draws on his experience
          building agent frameworks and developer tools - including AutoGen and
          AutoGen Studio - to provide a comprehensive guide to building,
          evaluating, and deploying multi-agent systems.
        </div>
        <Seo title={title} description={description} ogImage={ogImage} canonical={canonical} />
        <div className="flex-1 text-primary">
          <title>{'Designing Multi-Agent Systems' + ' | ' + title}</title>
          {showHeader && <Header meta={meta} link={link} />}
          {children}
        </div>
        {showLegalNotice && <LegalNotice />}
        <Footer />
      </div>
    )
  }

  return (
    <appContext.Consumer>
      {(context: any) => {
        if (restricted) {
          return (
            <div className="h-screen bg-yellow-100 ">
              {context.user && <LayoutView darkMode={context.darkMode} user={context.user} />}
              {!context.user && (
                <div className="flex items-center justify-center h-full">
                  <div className="text-center">
                    <h2 className="text-xl font-semibold mb-4">
                      Access Restricted
                    </h2>
                    <p className="text-secondary mb-4">
                      Please sign in to view this content.
                    </p>
                    <a
                      href="/"
                      className="bg-accent text-invert px-4 py-2 rounded-lg"
                    >
                      Go to Home
                    </a>
                  </div>
                </div>
              )}
            </div>
          );
        } else {
          return <LayoutView darkMode={context.darkMode} user={context.user} />;
        }
      }}
    </appContext.Consumer>
  );
};

export default Layout;
